import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const LinkIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="link" ref={ref} {...props}>
      <path d="M6.58,21.79a4.37,4.37,0,0,1-3.09-7.46L7.86,10A4.37,4.37,0,0,1,14,10,.75.75,0,1,1,13,11a2.86,2.86,0,0,0-4.05,0L4.55,15.4a2.87,2.87,0,0,0,4.06,4L11,17a.75.75,0,0,1,1.06,0,.74.74,0,0,1,0,1.06l-2.4,2.41A4.38,4.38,0,0,1,6.58,21.79ZM16.14,14l4.37-4.37a4.37,4.37,0,1,0-6.18-6.18L11.93,5.9a.74.74,0,0,0,0,1.06A.75.75,0,0,0,13,7L15.4,4.55a2.86,2.86,0,1,1,4,4.05L15.08,13A2.86,2.86,0,0,1,11,13,.76.76,0,0,0,10,14a4.39,4.39,0,0,0,6.18,0Z" />
    </Icon>
  ),
) as IconWithRender;

LinkIcon.displayName = 'LinkIcon';
LinkIcon.renderIcon = (props) => <LinkIcon {...props} />;
export default LinkIcon;
